import { SvgIconProps } from '@traba/types'

export function Cloudy({
  size,
  color = '#7A8A99',
  strokeWidth = '1.5',
  ...rest
}: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.26667 6.87855C2.46254 6.87855 1 8.24889 1 9.93928C1 11.6297 2.46254 13 4.26667 13C4.26882 13 4.27098 13 4.27313 13H10.3306C10.3315 13 10.3324 13 10.3333 13C12.9107 13 15 11.0424 15 8.62753C15 6.21269 12.9107 4.25507 10.3333 4.25507C8.42727 4.25507 6.78811 5.32575 6.06357 6.86024M4.26667 6.87855C4.69242 6.87855 5.09916 6.95487 5.47213 7.0937C5.69776 7.17768 5.96156 7.07627 6.06357 6.86024M4.26667 6.87855C3.80755 6.87855 3.37055 6.9673 2.97415 7.12747C2.709 6.71204 2.55556 6.2199 2.55556 5.69231C2.55556 4.20539 3.77434 3 5.27778 3C6.50468 3 7.542 3.80273 7.8821 4.90612C7.08434 5.3684 6.44633 6.0496 6.06357 6.86024"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}
